import { ReactNode, useState } from "react";
import { Context } from "./context";

export function ModelIdProvider({
  children,
  modelId: _modelId,
}: {
  children: ReactNode;
  modelId?: string;
}) {
  const [modelId, setModelId] = useState<string | undefined>(_modelId);

  return (
    <Context.Provider
      value={{
        modelId,
        setModelId,
      }}
    >
      {children}
    </Context.Provider>
  );
}
